import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import {
  isTachographKind,
  TachographKind,
} from "../../../../api/tachograph.types";
import GroupTachographPage from "../../../../pages/GroupPage/GroupTachographPage/GroupTachographPage";

export const Route = createFileRoute("/(app)/groups/$id/tachograph")({
  component: RouteComponent,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    kind: TachographKind;
  } => ({
    kind: isTachographKind(search.kind) ? search.kind : "manual-entry",
  }),
});

const routeApi = getRouteApi("/(app)/groups/$id");

function RouteComponent() {
  const group = routeApi.useLoaderData();
  const { kind } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <GroupTachographPage
      group={group}
      selectedKind={kind}
      onSelectKind={(kind) =>
        navigate({ search: { kind }, replace: true, resetScroll: false })
      }
    />
  );
}
